export default function Button({ title, direction, handleClick, color , isPrevious }) {
    return (
        <div className={`text-${direction} mx-1`}>
            <button
                className={`py-2 px-4 ${isPrevious ? "bg-[#f9b302] hover:bg-[#e3a200]" : "bg-[#5B5CFF] hover:bg-[#4747ff]"} text-white font-bold rounded hover:bg-[#e3a200] border border-solid transition duration-300`}
                //style={{ backgroundColor : `${color}`}}
                onClick={handleClick}
            >
                {title}
            </button>
        </div>
    )
}